import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from './Base';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function FightGameEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const period = periods[event.period].name;
  const fighterOne = players[event.fighterOne];
  const fighterTwo = players[event.fighterTwo];
  const team = teams[fighterOne.team].id;
  const isDraw = event.isDraw;

  return (
    <Base
      time={event.second}
      period={period}
      team={isDraw ? undefined : team}
      type="Fight"
    >
      <Typography variant="body2">
        <span className={classes.bold}>{fighterOne.name}</span>
        {isDraw ? ' and ' : ' beats up '}
        <span className={classes.bold}>{fighterTwo.name}</span>
        {isDraw && ' fight to a draw'}
      </Typography>
    </Base>
  )
}

export default FightGameEvent;
